// 用户中心-用户消息操作
const UserMessageRouterMap = [
  {
    path: '/user/message',
    component: Address => (require(['@/views/user/message'], Address))
  },
  {
    path: '/user/message-detail',
    component: Address => (require(['@/views/user/messageDetail'], Address))
  }
]

export default UserMessageRouterMap



// WEBPACK FOOTER //
// ./src/router/modules/user/message.js